export default __webpack_public_path__ + "static/media/derivative.48217b25.svg";